import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.REPORTS.PATH;

@Injectable()
export class ReportsService extends AbstractService<any> {
  constructor(
    http: HttpClient,
    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public downloadReports(type: string, params: any) {
    const headerData = { blob: 'true' };
    this.url = this.getUrl(type);
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}?${params}`,
      body: null,
      headers: headerData,
    });
  }

  private getUrl(type: string): string {
    return SERVICES.REPORTS[type]
      ? SERVICES.REPORTS[type].PATH
      : SERVICES.REPORTS.PATH;
  }
}
